import { useRequestStatus } from 'RequestStatusModule/hooks/useRequestStatus';
import {
  DEFAULT_TENANT_TABLE_VIEW,
  TENANT_TABLE_VIEW,
  TenantIsoStateIds,
} from 'TenantModule/constants';
import { useTenants } from 'TenantModule/hooks/useTenants';
import { useEffect, useState } from 'react';
import { fetchTenants } from 'TenantModule/thunks';
import { FetchTenantPayload } from 'TenantModule/types';
import { useDispatch } from 'react-redux';

const containerConfigs = {
  [TENANT_TABLE_VIEW.ACTIVE]: {
    isoStateId: TenantIsoStateIds.ActiveTenantTable,
    headerLabel: 'Tenant',
    fetchTenantAdditionalParams: {
      isArchived: false,
    },
  },
  [TENANT_TABLE_VIEW.ARCHIVED]: {
    isoStateId: TenantIsoStateIds.ArchivedTenantTable,
    headerLabel: 'Archived Tenant',
    fetchTenantAdditionalParams: {
      isArchived: true,
    },
  },
};

export const useTenantsTableData = ({
  filterParams,
}: {
  /**
   * Structured filters for POST /tenant/getAll. A new object identity
   * triggers a refetch, so submits refresh the table and view toggles
   * preserve the applied filters.
   */
  filterParams?: FetchTenantPayload | null;
} = {}) => {
  const [tenantTableView, setTenantTableView] = useState(DEFAULT_TENANT_TABLE_VIEW);
  const { getTenantByIsoState } = useTenants();
  const dispatch = useDispatch();

  const configs = containerConfigs[tenantTableView];
  const { isoStateId, headerLabel, fetchTenantAdditionalParams } = configs;
  const { topLevelOrder } = getTenantByIsoState({ isoStateId });
  const { requestStatus } = useRequestStatus({ requestStatusId: isoStateId });
  const isLoading = !requestStatus || requestStatus.isRequesting;

  useEffect(() => {
    // TODO: Fix with Redux Toolkit configureStore migration
    dispatch(
      fetchTenants({
        ...(filterParams || {}),
        ...fetchTenantAdditionalParams,
        meta: {
          isoStateId,
          requestStatusId: isoStateId,
        },
      }) as any,
    );
  }, [tenantTableView, isoStateId, fetchTenantAdditionalParams, filterParams, dispatch]);

  return {
    isLoading,
    setTenantTableView,
    tenantTableView,
    headerLabel,
    isoStateId,
    fetchTenantAdditionalParams,
    tenantIds: topLevelOrder || [],
  };
};
